
import { Component, Input, DoCheck, OnChanges } from '@angular/core';

import { SLEntity, SLEntityField, SLEntityType } from '../entity';
import { DossierModel } from '../../../dossier-model/dossier-model';
import { buildExtraFields, Field } from './utils';
import { forEach } from 'lodash';

@Component({
  selector: 'sl-entity-extra-fields-form',
  templateUrl: './entity-extra-fields-form.component.html',
})
export class SLEntityExtraFieldsFormComponent implements DoCheck, OnChanges {
  
  @Input()
  entity: SLEntity
  
  @Input()
  dossierModel: DossierModel

  @Input()
  inline: boolean = false;
  
  oldEntityType: SLEntityType
  extraFieldsMap: {[index:string]: SLEntityField};

  companyFields: Field[];
  personFields: Field[];

  fields: Field[];

  constructor(
    ) { }
    
  initForm() {
    this.extraFieldsMap = {};

    forEach(this.entity.extraFields, field => {
      this.extraFieldsMap[field.name] = field;
    });

    this.companyFields = buildExtraFields(this.dossierModel, 'COMPANY');
    this.personFields = buildExtraFields(this.dossierModel, 'PERSON');

    for (let field of [...this.companyFields, ...this.personFields]) {
      const model = this.extraFieldsMap[field.key] || new SLEntityField({
        name: field.key,
        value: field.values ? field.values[0] : '',
      });

      field.model = model;
    }

    this.fields = this.entity.type === 'COMPANY' ? this.companyFields : this.personFields;
  }

  ngOnChanges() {
    this.initForm();
  }

  ngDoCheck() {
    this.updateEntityExtraFields();
  }

  updateEntityExtraFields() {
    this.fields = this.entity.type === 'COMPANY' ? this.companyFields : this.personFields;
    
    if (this.oldEntityType !== this.entity.type) {
      
      this.entity.extraFields = this.fields.map(f => f.model);

      this.oldEntityType = this.entity.type;
    }
  }
}
